class FormManager extends ViewBasic {
	constructor(options) {
		super(options);
	}

	init() {
		this.addEvents();

	}

	addEvents() {
	}

	removeEvents() {
	}

}